import React, { useContext, useEffect } from "react";
import styled, { css } from "styled-components";
import Button from "./ActionButton";
import { useNavigate } from "react-router";
import { IonIcon } from "@ionic/react";
import { lockClosed } from "ionicons/icons";
import WorkspaceContext from "../WorkSpace/WorkspaceContext";

const Paragraph = styled.p`
  font-size: 1.4rem;
  margin-bottom: ${({ canvasScale }) => 4 * canvasScale}rem;
`;

const FormatPremiumStyles = css`
  ${({ canvasScale }) => `
  ${Paragraph} {
    font-size: ${canvasScale * 4.8}rem;
    color: #fff;
    gap: ${canvasScale * 2}rem;
  }
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `}
`;

const Container = styled.div`
  position: absolute;
  width: calc(100% + 4rem);
  height: calc(100% + 4rem);
  background-color: rgba(1, 1, 1, 0.8);
  text-align: center;
  padding: 3rem;
  z-index: 10;
  margin: -2rem;
  font-weight: bold;

  ${({ className }) => className === "format-premium" && FormatPremiumStyles}
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;

  ${({ canvasScale, isFormatPremium }) =>
    isFormatPremium
      ? css`
          transform: scale(${canvasScale});
          transform-origin: center;
        `
      : ""}
`;

export default function PremiumContentProtectiveLayer({
  className,
  showText = true,
  buttonSize = "1.4",
  buttonText = "Mudar de plano e desbloquear",
}) {
  const navigate = useNavigate();
  const { canvasScale } = useContext(WorkspaceContext);
  const isFormatPremium = className === "format-premium";

  return (
    <Container className={className} canvasScale={canvasScale}>
      {showText && (
        <Paragraph canvasScale={canvasScale}>
          Exclusivo para usuários premium <IonIcon icon={lockClosed} />
        </Paragraph>
      )}
      <ButtonWrapper
        canvasScale={canvasScale}
        isFormatPremium={isFormatPremium}
      >
        <Button
          action={() =>
            navigate("/metodo-pagamento?lookup_key=MONTHLY_PREMIUM_PLAN")
          }
          text={buttonText}
          size={buttonSize}
          icon={<IonIcon icon={lockClosed} />}
        />
      </ButtonWrapper>
    </Container>
  );
}
